var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'column' + _vm.checkWidth + _vm.checkOffset + _vm.checkAlign + _vm.checkMaxHeight,style:(_vm.checkMargin)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }